export default __webpack_public_path__ + "static/media/Michellee_Fox_AHV_In_Moms_We_Trust.09b40768.jpg";